export default __webpack_public_path__ + "static/Bm_EFTB_iMedical_ClaimGuide-f55c618a16e23963e6a0007b2339d41e.pdf";